const Summary: React.FC = () => {
  return <p>Success</p>
}

export default Summary
